<template>
  <div
    :key="globalId"
    ref="productElement"
    class="product-info"
  >
    <div
      :id="'container-product-price-' + globalId"
      ref="containerProductPrice"
      class="container-product-price"
    />
    <div class="cta-wrapper">
      <div
        :id="'container-product-link-' + globalId"
        ref="containerProductLink"
        :class="['container-product-link']"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    globalId() {
      return this.product.globalId || this.product.id;
    },
  },
  mounted() {
    this.safeAddElements();
  },
  destroyed() {
    this.safeRemoveElements();
  },
  beforeUpdate() {
    this.safeRemoveElements();
  },
  updated() {
    this.safeAddElements();
  },
  methods: {
    addElements() {
      this.refElement = this.$refs.productElement;
      if (window.products && window.products[this.globalId].priceElement && window.products[this.globalId].linkElement) {
        this.$refs.containerProductPrice.appendChild(window.products[this.globalId].priceElement);
        this.$refs.containerProductLink.appendChild(window.products[this.globalId].linkElement);
      } else {
        requestAnimationFrame(() => {
          this.addElements();
        });
      }
    },
    removeElements() {
      // wait until elements is in the dom during transition
      if (this.refElement && this.elementIsAttachedToDocument(this.refElement)) {
        requestAnimationFrame(() => {
          this.safeRemoveElements();
        });
      } else if (window.products && window.products[this.globalId].priceElement && window.products[this.globalId].linkElement) {
        // window.products[this.globalId].priceElementParent.appendChild(window.products[this.globalId].priceElement);
        // window.products[this.globalId].linkElementParent.appendChild(window.products[this.globalId].linkElement);
      }
    },
    safeAddElements() {
      try {
        this.addElements();
      } catch (error) {
        if (this.$debug) console.warn('Error on add elements in ProductInfo', this.globalId, error);
      }
    },
    safeRemoveElements() {
      try {
        this.removeElements();
      } catch (error) {
        if (this.$debug) console.warn('Error on remove elements in ProductInfo', this.globalId, error);
      }
    },
    elementIsAttachedToDocument(element) {
      while (element !== document && element.parentNode) {
        element = element.parentNode; // eslint-disable-line
      }
      return element === document;
    },
  },
};
</script>

<style lang="stylus" scoped>

$typoBt = @block {
  font-family: $mainFont;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
}

$button = @block {
  { $typoBt }
  width: 100%;
  padding: 14px 0
  box-sizing: border-box;
  border-radius: 6px;

  transition: background-color 0.25s ease-in-out, color 0.25s ease-in-out;
}

$input = @block {
  { $typoBt }
  padding: 12px 24px;
  height: auto;
  border: 1px solid currentColor;
  background-color: transparent;
  color: var(--inverted-text-color);
  border-radius: 50px;
  font-size: 14px;
}

$input-label = @block {
  position: absolute;
  margin-top: 10px !important;
  margin-left: 24px !important;
  top: 50%;
  font-family: $mainFont;
  font-size: 13px;
  font-weight: 400;
  background-color: var(--white-color);
  padding: 0 2px;
  transform: translate(0, -1.8rem) scale(1);
  color: var(--inverted-text-color);
}

makeButtonTheme($fontColor, $bgColor, $borderColor = null) {
  return @block {
    color: $fontColor;
    background-color: $bgColor;
    border: 1px solid $borderColor || $bgColor;
    border-radius: 50px;
    &:hover {
      color: $bgColor;
      background-color: $fontColor;
    }
  }
}

$bt-theme-primary = makeButtonTheme(var(--text-color), var(--main-color));
$bt-theme-primary-negative = makeButtonTheme(var(--inverted-text-color), var(--white-color), var(--inverted-text-color));
$bt-theme-secondary = makeButtonTheme(var(--text-color), var(--main-color));
$bt-theme-disabled = makeButtonTheme(var(--inverted-text-color), var(--white-color));

.container-product-price {
  display: none;
  margin-bottom: 10px;
  text-align: center;
  font-family: $mainFont;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

/* override mdp global product info style */
>>> .product-link {
  .product-add-form:has(+ .alert) {
    display: none;
  }
  .actions {
    display: inline-block;
    width: 100%;
  }

  /* product state 0 - add to cart button */
  .box-tocart {
    .action.tocart {
      { $button };
      { $bt-theme-primary };
      vertical-align: middle;
      &:after {
        font-size: 1em;
        font-weight: bold;
        vertical-align: middle;
        margin-top: -0.2em;
      }
    }
  }

  /* product state 1 - request mail alert */
  .product.alert {
    max-width: 280px;
    margin-left: auto; margin-right: @margin-left;

    .alert, .primary {
      { $button };
      width: 100%;
    }
    .alert {
      { $bt-theme-primary-negative }
      font-size: 14px;
    }
    .primary {
      { $bt-theme-secondary }
    }
    #sub-alert-email {
      { $input }
      &:focus, &:user-valid, &:user-invalid {
        & + label {
          { $input-label }
          transform: translate(0, -4rem) scale(0.8);
          background-color: var(--white-color);
        }
      }
    }
    label {
      { $input-label }
    }

    #sub-alert-email,
    .primary {
      margin-top: 10px;
    }

    .messages {
      /* messages container */
      margin: 10px 0 0 0;
    }

    .message {
      font-size: 13px;
      font-weight: 400;
      margin-bottom: 0;
      & + .message { margin-top: 10px; }
    }
  }

  /* product state 2 - product unavailable */
  /* product state 3 - out of stock */
  .disabled {
    { $typoBt }
    { $bt-theme-disabled }
    border-radius: 6px
  }
}
</style>
